<template>
	<div>
		<!-- <top></top> -->
		<div class="seach">
			<div class="flex align-center justify-between padding-sm bg-white margin-tb">
				<p class="text-sm text-666">以下为搜索<span>”{{seach_name}} ”</span>显示结果</p>
				<!-- <p class="flex align-center text-999 text-sm pointer" @click="back()">
					<i class="el-icon-back"></i>
					<span>返回</span>
				</p> -->
			</div>
			<div  v-if="total != 0">
				<div class="flex" v-if="type != 3">
					<div>
						<div v-if="type == 1" v-for="(item,indx) in list" :key="indx">
							<StationList :data="item" :width="786" :height="184" :size="24"></StationList>
						</div>
						<div v-if="type == 2" v-for="(item,indx) in list" :key="indx">
							<ResumeList :data="item" :width="786" :height="184" :size="24"></ResumeList>
						</div>
						<div v-if="type == 4" v-for="(item,indx) in list" :key="indx">
							<LeaseList :data="item" :width="786" :height="184" :size="24"></LeaseList>
						</div>
						<div v-if="type == 5" v-for="(item,indx) in list" :key="indx">
							<BidList :data="item" :width="786" :height="184" :size="24"></BidList>
						</div>
						<el-pagination
						 @current-change="handleCurrentChange"
						  background
						  page-size="9"
						  layout="prev, pager, next"
						  prev-text="上一页"
						  next-text="下一页"
						   :total="total"
						  >
						</el-pagination>
					</div>
				</div>
				<div v-if="type == 3">
					<el-row :gutter="15">
						<el-col :span="12"  v-for="(item,index) in list" :key="index"><SkillList :data="item" :type="type" :size="24"></SkillList></el-col>
					</el-row>
					<el-pagination
					 @current-change="handleCurrentChange"
					  background
					  page-size="9"
					  layout="prev, pager, next"
					  prev-text="上一页"
					  next-text="下一页"
					   :total="total"
					  >
					</el-pagination>
				</div>
			</div>
			<div class="text-center" v-else>
				<el-empty description="暂无数据"></el-empty>
			</div>
		</div>
	</div>
</template>

<script>
	import Top from '@/components/public/top.vue';
	import StationList from '@/components/list/station-list.vue';
	import ResumeList from '@/components/list/resume-list.vue';
	import LeaseList from '@/components/list/lease-list.vue';
	import SkillList from '@/components/list/skill-list.vue';
	import BidList from '@/components/list/bid-list.vue';
	export default {
		components: {
			Top,
			StationList,
			ResumeList,
			LeaseList,
			SkillList,
			BidList
		},
		name: '',
		data() {
			return {
				seach_name:'',//搜索名
				type:1,//1找活，2招工，3课程，4二手，5招标
				city:'',
				list:[],
				page:1,
				total:0,//
			}
		},
		created() {
			this.seach_name = this.$route.query.seachinfo
			this.type = this.$route.query.type
			this.city = this.$route.query.city
			this.seach()
		},
		methods: {
			back(){
				this.$router.back()
			},
			seach(){
				this.ajax('get', '/api/pc/work/search', {
					type:this.type,
					text:this.seach_name,
					area:this.city,
					page:this.page
				}, res => {
					if(res.status == 200){
						console.log('getUserList',res);
						this.list = res.data.data
						this.pageSize = res.data.lastpage
						if(this.page == 1){
							this.total =  Number(res.data.lastpage) * Number(res.data.data.length)
						}
					}
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.seach{
		width: 1210px;
		margin: 0 auto;
	}
	.title{
		position: relative;
		font-size: 22px;
		&:before{
			position: absolute;
			left: 0;
			top: 50%;
			transform: translateY(-50%);
			width: 6px;
			height: 26px;
			background: #09827B;
			content: '';
			
		}
	}
</style>



// WEBPACK FOOTER //
// src/view/tab/seach.vue